// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.94d57b5e9b2810c6363aadf022f11d05ae868410.js";
};